<template>
  <div class="formFooter">
    <p
      class="formFooter__info"
      v-html=" $t('partners.multisport.footer')"
    />
 
    <UiExpander
      :text-to-show="$t('partners.multisport.seeMore')"
      :text-to-hide="$t('partners.multisport.seeLess')"
      class="formFooter__button"
    >
      <p
        class="formFooter__info"
        v-html=" $t('partners.multisport.footerMore')"
      />
    </UiExpander>
  </div>
</template>

<style lang="scss" scoped>
.formFooter {
  padding: 3.2rem 0;

  &__button {
    padding-top: 1rem;
  }

  &__info {
    @include body-2-medium;
    color: $text-300;
    text-align: left;
  }
}
</style>
